module.exports = __webpack_public_path__ + "static/img/20180414165840.107d6289.jpg";